export default {
    create_sellergroup: async (data: any, {api, sellergroup}: {sellergroup: any, api: Function}) => api(`partner/sellergroups`, data, 'POST'),
};
